export class ResearchLeader {
  constructor(
    public uid = '',
    public name = ''
    ) {}
}
